// Car models service - now uses local config instead of Supabase
import { CAR_VIEWS, BASE_DIMENSIONS, CAR_MODELS as LOCAL_CAR_MODELS } from '../config/carModels';

let cachedCarModels = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes cache

// Fetch car models from local config
export const fetchCarModels = async () => {
  // Simply return the local config as an array
  return Object.values(LOCAL_CAR_MODELS);
};

// Get car models with caching (keeping cache for consistency, even though it's local data)
export const getCarModels = async () => {
  const now = Date.now();
  
  // Return cached data if it's still fresh
  if (cachedCarModels && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedCarModels;
  }
  
  // Use local config data directly
  cachedCarModels = { ...LOCAL_CAR_MODELS };
  cacheTimestamp = now;
  
  return cachedCarModels;
};

// Get a specific car model by ID
export const getCarModelById = async (id) => {
  const models = await getCarModels();
  return models[id] || null;
};

// Get all car models as an array
export const getAllCarModels = async () => {
  const models = await getCarModels();
  return Object.values(models);
};

// Clear the cache (useful when models are updated)
export const clearCarModelsCache = () => {
  cachedCarModels = null;
  cacheTimestamp = null;
};

// Export constants that are still needed
export { CAR_VIEWS, BASE_DIMENSIONS };

// Export CAR_MODELS directly for synchronous access
export const CAR_MODELS = LOCAL_CAR_MODELS;

// Initialize cache on first import (immediate since it's local data)
cachedCarModels = { ...LOCAL_CAR_MODELS };
cacheTimestamp = Date.now(); 